import gql from 'graphql-tag';
import { graphQuery } from '@services/commService';

const GET_ANALYTICS_QUERY = gql`
  query GetAnalytics(
    $businessUnitIds: [String!]
    $activePatientsRange: AnalyticsDateRangeInput
    $patientsStartedRange: AnalyticsDateRangeInput
  ) {
    analyticsOverview(
      businessUnitIds: $businessUnitIds
    ) {
      registeredUsers
      allTimeUsers
      usersByRole {
        role
        count
      }
    }
    analyticsPatients(
      businessUnitIds: $businessUnitIds
      activePatientsRange: $activePatientsRange
      patientsStartedRange: $patientsStartedRange
    ) {
      allTimePatients
      registeredPatients
      activePatients
      patientsStarted
      patientsPerTherapist
      courses {
        key
        count
      }
      ageGroups {
        min
        max
        count
      }
      prescriptionLength {
        min
        max
        count
      }
    }
    analyticsPractice {
      available
    }
    analyticsFeedback {
      available
    }
    analyticsTreatmentGoals {
      available
    }
  }
`;

const GET_ANALYTICS_BUSINESS_UNITS_QUERY = gql`
  query GetAnalyticsBusinessUnits {
    allBusinessUnits {
      id
      name
      isTest
    }
  }
`;

export const getAnalytics = async (variables) => {
  const response = await graphQuery(GET_ANALYTICS_QUERY, false, variables);
  if (response.error || !response.data) {
    throw new Error(response.error || 'Failed to fetch analytics data');
  }
  return response.data;
};

export const getAnalyticsBusinessUnits = async () => {
  try {
    const result = await graphQuery(GET_ANALYTICS_BUSINESS_UNITS_QUERY);
    if (!result) {
      return { data: null, errors: [] };
    }
    return { ...result, errors: result.errors || [] };
  } catch (error) {
    return { data: null, errors: [error] };
  }
};
